import { Text } from '@chakra-ui/react'
import {
  adminRoles,
  getPracticeUsersCollectionPath,
  practiceAdminRoles,
  USER_ROLES,
  UserRoleItem,
} from '@hb/shared'

import { ScreenContext, useApp, usePracticeAccess } from '@hb/react'
import { useContext, useMemo } from 'react'
import { useParams } from 'react-router'
import { SearchBarProvider } from '../../contexts/SearchBarContext'
import { useNavigate } from '../../hooks/navigation'
import { DataListTab } from '../../types/data'
import { adminColumns } from '../DataList/columns/users'
import { DataList } from '../DataList/DataList'
import { PageContainer } from '../Views/PageContainer'
import { AdminProfile } from './AdminProfile'
import { AdminProfileTabName } from './types'

const adminTabs: Record<string, DataListTab<UserRoleItem>> = {
  Admins: {
    // role: ['admin', 'super-admin'],
    // collection: 'user-roles',
    baseQuery: {
      collection: USER_ROLES,
      filters: [['role', 'in', adminRoles]],
    },
    defaultSort: {
      field: 'lname',
      order: 'asc',
    },
    searchStringPath: 'stringified',
    columns: adminColumns,
    itemName: 'Admin',
  },
}

const getAdminsTab = (
  appName: string,
  selectedPracticeId: string | null,
): DataListTab<UserRoleItem> | null => {
  if (appName === 'app') return adminTabs.Admins
  if (selectedPracticeId) {
    return {
      ...adminTabs.Admins,
      baseQuery: {
        collection: getPracticeUsersCollectionPath(selectedPracticeId),
        filters: [['role', 'in', practiceAdminRoles]],
      },
    }
  }
  return null
}

export const AdminsView = () => {
  const { adminId, displayedItem } = useParams()
  const { appName } = useApp()
  const { selectedPracticeId } = usePracticeAccess()

  const tabs = useMemo(() => {
    if (appName === 'app') return adminTabs
    if (selectedPracticeId) {
      const tab = getAdminsTab(appName, selectedPracticeId)
      if (!tab) return null
      return {
        Admins: tab,
      }
    }
    return null
  }, [appName, selectedPracticeId])
  const basePath = useMemo(() => (appName === 'app' ? '/admin/admins' : '/admins'), [appName])

  const { contentHeight } = useContext(ScreenContext)
  const navigate = useNavigate()
  if (!selectedPracticeId && appName === 'providers-app')
    return (
      <Text py={2} px={3} bg="whitesmoke" color="gray.500" borderRadius={6} boxShadow="md">
        You are not an admin of any practice
      </Text>
    )
  if (!tabs)
    return (
      <Text py={2} px={3} bg="whitesmoke" color="gray.500" borderRadius={6} boxShadow="md">
        Invalid app name
      </Text>
    )
  return (
    <PageContainer noFooter>
      <SearchBarProvider>
        <DataList height={contentHeight - 50} rootPath={basePath} tabs={tabs} />
        <AdminProfile
          onClose={() => {
            navigate(basePath)
          }}
          tab={displayedItem as AdminProfileTabName}
          onTabSelect={tabName => {
            navigate(`${basePath}/${adminId}/${tabName}`)
          }}
          userId={adminId}
        />
      </SearchBarProvider>
    </PageContainer>
  )
}
